<div class="c-cms-form" sk-field="{{field.fieldName}}">
    <div class="form-flex">
        <div class="form-label">{{if field.required == 1}}<span class="form-required">*</span>{{/if}}{{field.displayName}}</div>
        <div class="form-value">
            <div class="form-row">
                <div class="c-form-time">
                    <input type="text" class="form-control" readonly skf-value="$field.formatValue" skf-focus="$parent.changeTime('{{field.fieldName}}')"/>
                    <span class="time-icon"></span>
                </div>
            </div>
            <div class="form-row form-error" skf-if="$field.dirty && $field.invalid" skf-text="$field.validationMessage"></div>
        </div>
    </div>
</div>